import angular from "angular";

const moduleName = "AaApp.Storage";
export default moduleName;

angular.module(moduleName, []);
